import { isDefined } from './type-guards';

interface ParseFloatOptions {
  min?: number;
  max?: number;
}

export const parseFloatWithFallback = (
  input: string | null | undefined,
  fallback: number,
  { min = -Infinity, max = Infinity }: ParseFloatOptions = {},
): number => {
  if (!isDefined(input)) return fallback;
  const parsed = parseFloat(input);
  return Number.isNaN(parsed) ? fallback : Math.min(max, Math.max(min, parsed));
};
